import { useContext } from "react";
import {
  CardMetricsOptionsContext,
  CardMetricsOptionsContextType,
} from "@/providers/CardMetricsOptions.provider";

export const useCardMetricsOptions = (): CardMetricsOptionsContextType => {
  const context = useContext(CardMetricsOptionsContext);
  if (!context) {
    throw new Error(
      "useCardMetricsOptions must be used within a CardMetricsOptionsProvider"
    );
  }
  return context;
};
